import { Box, Flex, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { AwardCriterionDto } from "../../../../../autogen/bff-api";

interface Props {
  criteria: AwardCriterionDto[];
}

// t('Total weighting') t('must be 100%')

export const WeightSummary = ({ criteria }: Props) => {
  const { t } = useTranslation();
  const total = criteria.reduce((sum, c) => sum + (c.weight?.number ?? 0), 0);
  const isValid = total === 100;

  return (
    <Box
      data-testid="weight-summary"
      borderWidth="1px"
      borderRadius="lg"
      borderColor={isValid ? "smSuccessSoftBorder" : "smWarningSoftBorder"}
      bg={isValid ? "smSuccessSoft" : "smWarningSoft"}
      px="4"
      py="3"
      mt="6"
      mb="6"
    >
      <Flex align="center" justify="space-between">
        <Text fontWeight="semibold" fontSize="sm">
          {t("Total weighting")}
        </Text>
        <Text fontWeight="bold" color={isValid ? "smSuccess" : "smWarning"}>
          {total}%
        </Text>
      </Flex>
      {!isValid && (
        <Text fontSize="xs" color="smWarning" mt="1">
          {t("must be 100%")}
        </Text>
      )}
    </Box>
  );
};
